import React, { useEffect, useState } from 'react';
import { SubmitButton as StyledSubmitButton } from 'components/EpisodeEditorPublish/components/InteractivePoll/styles';

export function SubmitButton(props: {
  isSubmitting: boolean;
  pristine: boolean;
}) {
  const { pristine, isSubmitting } = props;
  const [isActive, setIsActive] = useState(false);
  function getText() {
    if (isActive && isSubmitting) {
      return 'Saving...';
    }
    return 'Publish question';
  }

  useEffect(() => {
    if (!isSubmitting) {
      setIsActive(false);
    }
  }, [isSubmitting]);

  return (
    <StyledSubmitButton
      kind="button"
      color="purple"
      type="submit"
      isDisabled={isSubmitting || pristine}
      onClick={() => {
        setIsActive(true);
      }}
    >
      {getText()}
    </StyledSubmitButton>
  );
}
